import { useState } from 'react';
import { CompatibilityWarning } from './CompatibilityWarning';
import {
  checkBrowserCompatibility,
  isCompatibleBrowser,
} from '../lib/browserCompatibility';

export function BrowserCompatibilityBanner() {
  const [showModal, setShowModal] = useState(false);

  const isCompatible = isCompatibleBrowser();
  
  // Don't show banner if browser is compatible
  if (isCompatible) {
    return null;
  }

  const checks = checkBrowserCompatibility();
  const criticalIssues = checks.filter(
    (check) => check.critical && !check.supported
  );

  const getReasonText = () => {
    if (criticalIssues.length === 1) {
      const issue = criticalIssues[0];
      switch (issue.feature) {
        case 'Web Bluetooth':
          return 'Your browser doesn\'t support Web Bluetooth, which is required to connect to smart trainers.';
        case 'Modern JavaScript':
          return 'Your browser is too old and doesn\'t support modern web features required for this app.';
        default:
          return `Your browser doesn't support ${issue.feature}, which is required for this app.`;
      }
    } else {
      return `Your browser is missing ${criticalIssues.length} critical features required for this app.`;
    }
  };

  return (
    <>
      <div className="mb-4 p-4 bg-red-50 border-2 border-red-200 rounded-lg">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center mb-2">
              <span className="text-red-600 text-xl mr-2">⚠️</span>
              <h3 className="text-red-800 font-semibold">Browser Not Supported</h3>
            </div>
            <p className="text-red-700 text-sm mb-3">
              {getReasonText()}
            </p>
            <p className="text-red-600 text-xs">
              Recommended: Use Google Chrome or Microsoft Edge for full compatibility.
            </p>
          </div>
          <button
            onClick={() => setShowModal(true)}
            className="ml-4 flex-shrink-0 w-6 h-6 bg-red-100 hover:bg-red-200 text-red-600 rounded-full flex items-center justify-center text-sm font-bold transition-colors"
            title="View detailed compatibility information"
          >
            i
          </button>
        </div>
      </div>

      {showModal && (
        <CompatibilityWarning onClose={() => setShowModal(false)} />
      )}
    </>
  );
}